import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";
import { API, API_RESPONSE_STATUS_CODES } from "../Utils/Constants";
import { callAPI } from "../config/AxiosTemplate";

/**
 * This function will call status count API
 * @param {*} monthValue -Selected month value
 * @param {*} yearValue -Selected year value
 * @param {*} getStatusCountActionCallback -Callback function
 */

export const getStatusCountAction = (monthValue, yearValue, callback) => {
  let data =
    API.getLoanApplicationStatusCount + "?monthCount=12&month=" +
      monthValue +
      "&year=" +
      yearValue;
    let origin = window.location.hash === `#${APPLICATION_CONFIGURATIONS.path.dashboardAppresta}` ? "APPRESTA" : "";
      if(origin !== "") {
        data += "&origin=" + origin
      }
  callAPI("GetLoanApplicationStatusCount", data, "GET", {}, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      callback(apiResponse.data.data);
    } else {
      callback(null);
    }
  });
};

/**
 * This function will call branchwise count API
 * @param {*} monthValue -selected month
 * @param {*} yearValue -selected year
 * @param {*} getBranchwiseCountActionCallback -callback function
 */
export const getTotalCountOfLoansForBarchartAction = (monthValue, yearValue, callback) => {
  let data =
    API.getBarGraphCount +
    "?monthCount=12&month=" +
    monthValue +
    "&year=" +
    yearValue;
  let origin = window.location.hash === `#${APPLICATION_CONFIGURATIONS.path.dashboardAppresta}` ? "APPRESTA" : "";
  if(origin !== "") {
    data += "&origin=" + origin
  }
  callAPI("GetBarGraphCount", data, "GET", {}, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      callback(apiResponse.data.data);
    } else {
      callback(null);
    }
  });
};
